import * as React from 'react';

export default class FooterLink extends React.Component<any> {

  public render() {
    const { to } = this.props;
    
    const linkProps = {...this.props};
    delete(linkProps.to);

    const webUrl = process.env.REACT_APP_WEB_URL;

    return (
      <a 
        {...linkProps}
        href={(/^(http:|https:)/i).test(to) ? to : `${webUrl}${to}`} 
      >
        {this.props.children}
      </a>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer/components/Link/Link.tsx